var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 13C12.3334 12.0696 12.3334 11.6044 12.2185 11.2259C11.96 10.3736 11.293 9.70669 10.4408 9.44816C10.0623 9.33333 9.59706 9.33333 8.66668 9.33333H5.33336C4.40298 9.33333 3.93779 9.33333 3.55926 9.44816C2.70699 9.70669 2.04005 10.3736 1.78151 11.2259C1.66669 11.6044 1.66669 12.0696 1.66669 13M10 4C10 5.65685 8.65687 7 7.00002 7C5.34317 7 4.00002 5.65685 4.00002 4C4.00002 2.34315 5.34317 1 7.00002 1C8.65687 1 10 2.34315 10 4Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.c68079a3fe798b85f285b703b2a239b2.svg";
export { ForwardRef as ReactComponent };